export interface Shift {
    readonly id: number;
    readonly name: string;
    /** Lab-local time of day, `HH:mm:ss`. */
    readonly startTime: string;
    readonly endTime: string;
    /** True when the window spans midnight and therefore ends the following day. */
    readonly crossesMidnight: boolean;
    readonly isActive: boolean;
    readonly modifiedDate: string;
    readonly modifiedBy?: string | null;
}
